
<template>
  <div class="task-container">
    <!-- 列表头部栏 -->
    <r-pointer :textName="`${$t('taskData.taskDataM')}`">
    </r-pointer>
    <!-- 搜索模块 -->
    <r-search
      class="p_search"
      :hasISenior="false"
      @on-blur="getCommonSearchOpt"
      @on-search="handleCommonSearch">
      <div slot="operation">
        <a-button
          type="primary"
          :disabled="selectedRowNum!=0"
          @click="handleAdd">{{ $t('operation.btnAdd') }}</a-button>
        <a-button
          type="danger"
          :disabled="selectedRowNum<1"
          @click="handleDel(selectedRowData)">{{ $t('operation.btnDel') }}</a-button>
      </div>
    </r-search>
    <!-- 表格列表 -->
    <a-table
      :columns="columns"
      :dataSource="dataList"
      :pagination="pagination"
      :rowSelection="rowSelection"
      :loading="loading"
      rowKey="id">
      <!-- 空间名 -->
      <span slot="queueName" slot-scope="text">
        <template>
          <div>{{ text }}</div>
        </template>
      </span>
      <!-- 最大失败尝试次数 -->
      <span slot="failTryTimes" slot-scope="text">
        <template>
          {{ text }}
        </template>
      </span>
      <!-- 空间描述 -->
      <span slot="queueDesc" slot-scope="text">
        <template>
          {{ text || $t('operation.notAvailable') }}
        </template>
      </span>
      <!-- 过去24小时状况 -->
      <span slot="aggData" slot-scope="record">
        <template>
          {{ $t('taskData.count') }}：{{ record.aggData.count }},
          {{ $t('taskData.success') }}：{{ record.aggData.succ }},
          {{ $t('taskData.fail') }}：{{ record.aggData.fail }},
          {{ $t('taskData.other') }}：{{ record.aggData.other }}
        </template>
      </span>
      <!-- 操作 -->
      <span slot="operation" slot-scope="record">
        <template>
          <a @click="handleModify(record)">{{ $t('operation.variateModify') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDel(record.id)">{{ $t('operation.variateDel') }}</a>
          <br>
          <a @click="handleClear(record.queueName)">{{ $t('operation.clearRecord') }}</a>
          <a-divider type="vertical" />
          <a @click="handleViewData(record)">{{ $t('operation.viewData') }}</a>
        </template>
      </span>
    </a-table>
    <!-- 新增/修改任务数据Modal -->
    <a-modal
      :title="mTitle"
      v-model="mShow"
      :destroyOnClose="false"
      :confirmLoading="modalLoading"
      :okText="`${$t('formAbout.ok')}`"
      :cancelText="`${$t('formAbout.cancel')}`"
      @ok="handleOk"
      @cancel="handleCancel">
      <!-- 表单 -->
      <a-form
        :form="form">
        <!-- 表单小标题 -->
        <r-pointer
          :textName="`${$t('taskData.info')}`"
          :style="'padding: 0 0 15px 0;box-shadow: none;margin-bottom: 0;'">
        </r-pointer>
        <!-- 空间名 -->
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${$t('formAbout.taskData.name')}`"
        >
          <a-input
            v-decorator="[
              'queueName',
              {rules: [{ required: true, pattern: new RegExp(/^[\u4e00-\u9fa5]{1,32}$|^.{2,64}$/), message: `${$t('formAbout.taskData.nameVMsg')}` }]}
            ]"
            :placeholder="`${$t('formAbout.taskData.namePlaceH')}`"
          />
        </a-form-item>
        <!-- 空间项最大数 -->
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${$t('formAbout.taskData.queueMaxItems')}`"
        >
          <a-input-number
            style="width: 100%;"
            v-decorator="[
              'queueMaxItems',
              {
                initialValue: 500,
                rules: [{ required: true, type: 'number', min: 1, max: 10000, message: `${$t('formAbout.taskData.queueMaxItemsVMsg')}` }]
              }
            ]"
            :placeholder="`${$t('formAbout.taskData.queueMaxItemsPlaceH')}`"
          />
        </a-form-item>
        <!-- 最大失败次数 -->
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${$t('formAbout.taskData.failTryTimes')}`"
        >
          <a-input-number
            style="width: 100%;"
            v-decorator="[
              'failTryTimes',
              {rules: [{ required: true, type: 'number', min: 0, max: 99999, message: `${$t('formAbout.taskData.failTryTimesVMsg')}` }]}
            ]"
            :placeholder="`${$t('formAbout.taskData.failTryTimesPlaceH')}`"
          />
        </a-form-item>
        <!-- 空间描述 -->
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${$t('formAbout.taskData.description')}`">
          <a-textarea
            v-decorator="[
              'queueDesc',
              {
                initialValue: '',
                rules: [{
                   min: 0,
                   max: 128,
                  message: `${$t('formAbout.taskData.failqueueDescVMsg')}`,
                }]
              }
              ]"
            :placeholder="`${$t('formAbout.taskData.descriptionPlaceH')}`"
            :autosize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
        <!-- 表单小标题 -->
        <r-pointer
          :textName="`${$t('taskData.jurisdiction')}`"
          :style="'padding: 0px 0 15px 0;box-shadow: none;margin-bottom: 0;'">
        </r-pointer>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${$t('formAbout.taskData.robot')}`"
        >
          <a-select
            mode="multiple"
            v-decorator="[
              'robotsNo',
              {
                rules: [{ required: true, message: `${$t('formAbout.taskData.robotVMsg')}` }]
              }]"
            @change="setRobotsId">
            <a-select-option value="all"> {{ $t('formAbout.all') }} </a-select-option>
            <a-select-option v-for="(item, index) in robotList" :key="index" :value="item.agentNo"> {{ item.agentAlias || item.agentNo }} </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { apiTaskData } from '@/api/taskDataM'
import { apiRobot } from '@/api/robot'

// import { transformRequest } from '@/utils/util'
import { tipMsg, modalTip } from '@/utils/tipTools'

export default {
  data () {
    // 表格列信息
    const columns = [
      {
        title: this.$t('taskData.spaceName'),
        align: 'left',
        // width: 300,
        dataIndex: 'queueName'
      },
      {
        title: this.$t('taskData.maxFailedAttempts'),
        align: 'left',
        // width: 300,
        dataIndex: 'failTryTimes'
      },
      {
        title: this.$t('taskData.spaceDescription'),
        align: 'left',
        dataIndex: 'queueDesc',
        scopedSlots: { customRender: 'queueDesc' }
        // width: 220
      },
      {
        title: this.$t('taskData.Last24Hours'),
        align: 'left',
        key: 'aggData',
        // width: 180,
        scopedSlots: { customRender: 'aggData' }
      },
      {
        title: this.$t('operation.tableOperation'),
        key: 'operation',
        align: 'right',
        width: 220,
        scopedSlots: { customRender: 'operation' }
      }
    ]
    // 表单布局信息
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 }
    }
    const formTailLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 8, offset: 0 }
    }
    return {
      checkNick: false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this),
      modalLoading: false, // 控制确定按钮的loading状态
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      columns,
      // 任务列表查询入参
      params: {
        queueName: '', //	空间名
        queueDesc: '', //	空间描述
        queueMaxItems: '', // 空间数最大项
        failTryTimes: '', //	失败尝试次数
        robotsNo: '' //	机器号
      },
      // 列表数据
      dataList: [],
      pagination: {
        current: 1, // 当前页默认为 1
        total: 0,
        pageSize: 10,
        size: 'samll',
        showSizeChanger: true, // 可以改变 pageSize
        showTotal: total => `${this.$t('operation.total')} ${total} ${this.$t('operation.items')}，`,
        showQuickJumper: true, // 可以快速跳转至某页
        onChange: this.handlePagition,
        onShowSizeChange: this.handlePageSize
      },
      loading: false,
      // 机器人列表
      robotList: [],
      // 机器人列表搜索入参
      senParams: {
        agentAlias: '',
        expireDateBegin: '',
        expireDateEnd: '',
        dataStatus: '',
        installTimeBegin: '',
        installTimeEnd: ''
      },
      // 表格选择功能
      rowSelection: {
        onChange: this.onSelectChange
      },
      // 批量选择的数据
      selectedRowData: '',
      // 选中数据的条数，用来控制表格下方多选操作按钮的可操作性
      selectedRowNum: 0,
      // Modal相关
      mShow: false, // 显示/隐藏
      mTitle: this.$t('taskData.add'), // 标题
      isChange: false, // 判断新增/修改操作
      curVariate: '' // 当前任务数据信息
    }
  },
  created () {
    this._fetchList()
    // 获取机器人列表
    this._fetchRobotList()
  },
  methods: {
    // 设置机器人select框的值
    setRobotsId (value, option) {
      // console.log(value)
      // 判断选中机器人选项中是否有全部
      if (value.length > 1 && value.indexOf('all') !== -1) {
        tipMsg('warning', `${this.$t('formAbout.robotSelectTip')}`)
        // 将除开 all 以外的值，清除掉
        setTimeout(() => {
          this.form.setFieldsValue({
            robotsNo: ['all']
          })
        }, 0)
      }
    },
    /**
     * 获取机器人列表数据
     */
    _fetchRobotList () {
      apiRobot.list(this.senParams, 1, 10000).then(data => {
        this.robotList = data.items
      })
    },
    // 表格分页
    handlePagition (page, pageSize) {
      // console.log(page)
      this.pagination.current = page
      this._fetchList()
    },
    // 表格切换size
    handlePageSize (current, pageSize) {
      this.pagination.pageSize = pageSize
      this._fetchList()
    },
    // 表格选中操作
    onSelectChange (selectedRowKeys, selectedRows) {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
      this.selectedRowData = selectedRowKeys.join(',')
      this.selectedRowNum = selectedRowKeys.length
    },
    /**
     * 获取任务列表数据
     */
    _fetchList () {
      this.loading = true
      // 获取任务列表数据
      apiTaskData.list(this.params, this.pagination.current, this.pagination.pageSize).then(data => {
        // console.log(data)
        this.pagination.total = data.total
        this.dataList = data.items
        this.loading = false
      })
    },
    /**
     * 失焦获取普通搜索条件值
     */
    getCommonSearchOpt (opt) {
      // alert(opt)
      this.params.queueName = opt
    },
    /**
     * 模糊搜索
     */
    handleCommonSearch () {
      // alert('模糊搜索')
      this.pagination.current = 1
      this._fetchList()
    },
    // Modal点击确定 关闭时
    handleOk (e) {
      // console.log(e)
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          // 遍历form获取到的字段，赋值给params
          Object.keys(values).forEach(key => {
            if (typeof values[key] === 'boolean') {
              values[key] = values[key] ? 'Yes' : 'No'
            }
            if (key === 'robotsNo') {
              values[key] = values[key].join(',')
            }
          })
          // console.log(values)
          this.isChange ? this.realMod(values) : this.realAdd(values)
        }
      })
    },
    // 新增任务数据
    realAdd (params) {
      this.modalLoading = true
      apiTaskData.add(params).then(data => {
        // console.log(data)
        this.modalLoading = false
        tipMsg('success', `${this.$t('msg.addSuceess')}`)
        this.handleCancel()
        // 刷新列表数据
        this._fetchList()
      }).catch(err => {
        console.log(err)
        this.modalLoading = false
      })
    },
    // 修改任务数据
    realMod (params) {
      this.modalLoading = true
      apiTaskData.modify({
        id: this.curVariate.id,
        ...params
      }).then(data => {
        // console.log(data)
        this.modalLoading = false
        tipMsg('success', `${this.$t('msg.modifyOk')}`)
        this.handleCancel()
        // 刷新列表数据
        this._fetchList()
      })
    },
    // Modal点击遮罩层或右上角叉或取消按钮的回调 关闭时
    handleCancel (e) {
      // console.log(e)
      // 清空表单的值及校验状态
      this.form.resetFields()
      // 关闭弹窗
      this.mShow = false
    },
    // 新增
    handleAdd () {
      // 打开modal
      this.mShow = true
      this.isChange = false
      this.mTitle = this.$t('taskData.add')
    },
    // 修改
    handleModify (row) {
      console.log(row)
      this.curVariate = row
      // 打开modal
      this.mShow = true
      this.isChange = true
      // 设置国际化的标题
      this.mTitle = this.$t('taskData.modify')
      const setFields = {}
      Object.keys(this.params).forEach(key => {
        if (key !== 'page' && key !== 'size') {
          // console.log(key + ' ' + row[key])
          setFields[key] = row[key]
        }
        if (key === 'robotsNo') {
          // 机器人select值，string转为 Array
          setFields['robotsNo'] = row[key] ? row[key].split(',') : []
        }
      })
      console.log(setFields)
      /**
       * 修改时，给表单赋值的注意点：
       * 1. 利用settimeout对赋值操作，进行延迟0毫秒
       * 2. 不要把modal的属性destroyOnClose设置为true，它的作用是关闭时销毁 Modal 里的子元素
       */
      setTimeout(() => {
        this.form.setFieldsValue(setFields)
      }, 0)
    },
    // 删除
    handleDel (rowID) {
      // console.log(row)
      this.realDel(rowID)
    },
    // 删除，可批量删除
    realDel (delItem) {
      modalTip(
        'confirm',
        `${this.$t('taskData.delTipMsg')}`,
        () => {
          apiTaskData.del({
            id: delItem
          }).then(data => {
            tipMsg('success', `${this.$t('msg.delSuceess')}`)
            // 清空之前选中的数据
            this.cleanSelectd()
            // 重新获取数据列表
            this._fetchList()
          })
        }
      )
    },
    // 清空之前选中的数据
    cleanSelectd () {
      // console.log(this.selectedRowData)
      this.selectedRowData = ''
      this.selectedRowNum = 0
    },
    // 清空记录
    handleClear (queueName) {
      modalTip(
        'confirm',
        `${this.$t('taskData.clearTipMsg')}`,
        () => {
          apiTaskData.clear({
            queueName: queueName
          }).then(data => {
            tipMsg('success', `${this.$t('msg.delSuceess')}`)
            // 清空之前选中的数据
            this.cleanSelectd()
            // 重新获取数据列表
            this._fetchList()
          })
        }
      )
    },
    // 查看数据
    handleViewData (row) {
      // console.log(queueName)
      // tipMsg('info', '下一迭代开发')
      // 前往查看数据
      this.$router.push({
        path: `/taskViewData/${row.queueName}/${row.id}`
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .task-container {
    background-color: #fff;
    padding: 0 24px 12px;
    position: relative;
  }
  // 表格底部，多选操作涉及的按钮
  .multi-select {
    position: absolute;
    bottom: 32px;
    width: 50%!important;
    min-width: 300px;
    button {
      margin-right: 5px;
    }
  }
  // 高级搜索的按钮
  .btn_gruop {
    margin: 10px 0 10px 84px;
  }
  // 表单
  .ant-row {
    margin-top: 5px;
    width: 100%;
  }
  // 表格
  .ant-table-wrapper {
    padding-top: 10px;
  }
</style>
